import React from 'react';

import QR from 'qrcode.react';
import { connect } from 'react-redux';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import { fetchFeaturedPlaylist, fetchHomePlaylist, fetchActivePlaylist, fetchMyPlaylist, fetchFollowedCollection } from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { BACK, ENTER, RIGHT, LEFT, EXIT } from '../util/remoteButtons';
import { setLogoFlag, setMuteFlag } from './utils';


export class Pair extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'None';
    this.selectedBtn1 === 'No';

    this.state = {
      open: false,
    };
  }

  async componentDidMount() {
    let pairInterval = null;
    setTimeout(() => {
      const { back } = this.refs;
      back.focus();  
      this.selectedBtn = 'Back';    
    }, 300);
    window.history.pushState("backhandler", null, null);
    const pair = async () => {
      try {
        const deviceResult = await this.props.fetchDevice(this.props.app.FireTVDeviceId);
        if (deviceResult.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          setLogoFlag(false);
          setMuteFlag(deviceResult.payload.mute);
          clearInterval(pairInterval);
          const emailId = deviceResult.payload._embedded.user.email;
          const userId = deviceResult.payload._embedded.user.id;
          await this.props.mobileDeviceId(userId);
          // TODO: Move this into a redux action. Functionality is duplicated on the splash page.
          const response = await bdReq.post('/emailLogin', { emailId });
          if (response.success) {
            bdAuth._storeToken(response.body);
          }

          const fetchUser = await this.props.fetchUser();
          if (fetchUser.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchSubscription = await this.props.fetchSubscription();
          if (fetchSubscription.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
          if (fetchFeaturedPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchMyPlaylist = await this.props.fetchMyPlaylist();
          if (fetchMyPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFollowedCollection = await this.props.fetchFollowedCollection();
          if (fetchFollowedCollection.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchHomePlaylist = await this.props.fetchHomePlaylist();
          if (fetchHomePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchActivePlaylist = await this.props.fetchActivePlaylist('Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
          if (fetchActivePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          clearInterval(this.onlineStatusInterval);
          this.props.history.push('/playlist/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
        }
      } catch (e) {
        console.log(e);
      }
    };

    pairInterval = setInterval(() => pair(), 3000);

    return () => {
      clearInterval(pairInterval);
    };
  }

  handleKeyDown(e) {
    e.stopPropagation();
    e.preventDefault();
    switch (e.which) {
      case ENTER:
        if (this.selectedBtn === 'Back') {
          this.props.history.goBack();
        }
        break;
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        // if (window.history.state !== "backhandler") {
        //   window.history.pushState("backhandler", null, null);
        // } else {
          this.props.history.goBack();
        // }
        break;
    }
  }

  render() {
    return (
      <div className="UpgradeWrapper">
        <div className="qrCodeWrapper">
          <div className="content-wrapper">
            <div className="text-wrapper">
              PAIR WITH SMARTPHONE
            </div>
            <div className="scan-text-wrapper">
              Scan the below QR code using the smartphone app to pair your display
            </div>
          </div>
          <div className="qr-wrapper">
            <QR className="QRCode" value={this.props.app.FireTVDeviceId} size={300} renderAs="svg" />
            {/* <img className="img-wrapper" src="/assets/img/blackdovelogo.png" alt="" /> */}
          </div>
        </div>
        <div className="downloadButtonWrapper" onKeyDown={this.handleKeyDown}>
          <img className="downloadImg-wrapper" src="/assets/img/TV.png" alt="" />
          <img className="iphone-wrapper" src="/assets/img/iPhone.png" alt="" />
          <div className="info-Content-Wrapper">
            <div className="art-wrapper">
              ART THAT YOU WILL LOVE AT YOUR FINGERTIPS
            </div>
            <div className="download-art-wrapper">
              Download the mobile app today to discover, collect and share the newest artworks.
              Use the app to showcase the art that speaks to you on a range of displays across your home, or business.
            </div>
          </div>
          <div className="button-Wrapper" style={{top:'80%', padding:'3%'}}>
          <button id="back" ref="back" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-backbtn" onClick={() => this.props.history.goBack()}>Close</button>
          {/* <button id="logout" ref="download" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-downloadbtn" onClick={() => this.logout()}>Download iOS App</button> */}
          </div>
          </div>
        {/* <img className="Logo1" src="assets/img/blackdove-logo-2020.png" alt="" />*/}
        {/*<img className="BottomApps" src="assets/img/apps-image.png" alt="" /> */}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchFollowedCollection: () => dispatch(fetchFollowedCollection()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app,
  };
}, mapDispatchToProps)(Pair);
